export default {
  "b2b.produkty-grid-columns.id.label": "Id",
  "b2b.produkty-grid-columns.nazev.label": "Name",
  "b2b.produkty-grid-columns.popis.label": "Description",
  "b2b.produkty-grid-columns.zkratka.label": "Abbreviation",
  "b2b.produkty-grid-columns.uzivaNapajeni.label": "It uses power",
  "b2b.produkty-grid-columns.vylucny.label": "Exclusive",
  "b2b.produkty-grid-columns.parkovani.label": "Parking",
  "b2b.produkty-grid-columns.bezCasu.label": "Without time"
};
